import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";

export class AccountAutocompleteCtrl implements IController {

  doDisable: boolean;
  selected: boolean;
  isDemand: boolean;
  ngPlaceholder: any;
  isRequired: boolean;

  onSelect: Function;

  private loadLimit: number = 10;
  private searchText: string;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory, public accountNameFilter) {
  }

  $onChanges(changes) {
    if (changes.isDemand && !changes.isDemand.isFirstChange()) {
      this.searchText = '';
    }
  }

  querySearch(text) {
    const query = {
      isDemand: this.isDemand,
      limit: this.loadLimit,
      descending: true
    };
    return this.$accounts().$getAll(_.assign({}, query, {query: text}));
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountAutocomplete', {
    require: {
      form: '^form'
    },
    bindings: {
      doDisable: '<?',
      selected: '<?',
      isDemand: '<?',
      ngPlaceholder: '@?',
      isRequired: '<?',
      onSelect: '&'
    },
    template: require('./account-autocomplete.html').default,
    controller: AccountAutocompleteCtrl
  });
